import { render, staticRenderFns } from "./emailCampaigns.vue?vue&type=template&id=63ddaa5e"
import script from "./emailCampaigns.vue?vue&type=script&lang=js"
export * from "./emailCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports